import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  position: relative;
`;

export const Badge = styled.button`
  background: none;
  border: 0;
  position: relative;
`;

export const MenuList = styled.div`
  position: absolute;
  width: 165px;
  left: calc(50% - 85px);
  top: calc(50% + 27px);
  border-radius: 4px;
  padding: 5px;
  background: #fffafa;
  text-align: center;
  z-index: 1;
  box-sizing: border-box;
  box-shadow: 2px 2px 2px rgba(12, 13, 14, 0.15);
  display: ${props => (props.visible ? 'block' : 'none')};

  &::before {
    content: '';
    position: absolute;
    left: calc(50% - 20px);
    top: -20px;
    width: 0;
    height: 0;
  }

  @media (max-width: 1024px) {
    left: calc(50% - 93px);
  }

  @media (max-width: 768px) {
    left: calc(50% - 120px);
    z-index: 1;
  }

  @media (max-width: 320px) {
    left: calc(50% - 50px);
    width: 72px;
    z-index: 1;
  }
`;

export const MenuItens = styled.div`
  color: #000;

  & + div {
    padding-top: 10px;
    margin-top: 10px;
    border-top: 1px solid rgba(12, 13, 14, 0.15);
  }

  button {
    font-size: 1rem;
    border: 0;
    background: none;
    margin: 1px;
    font-weight: bold;
    color: #20303d;

    &:hover {
      color: ${darken(0.1, '#1c2156')};
    }
  }
`;
